import { NamedLink } from '../../../../components';
import { createSlug } from '../../../../util/urlHelpers';
import { MARKETPLACE_JOIN_CALENDLY_URL } from '../../../../util/enums';
import css from './MarketplaceSection.module.css';

// ── Icons ──────────────────────────────────────────────────────────
const BedIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 20V10C2 8.9 2.9 8 4 8H20C21.1 8 22 8.9 22 10V20H20V17H4V20H2ZM4 15H20V10H4V15Z" fill="#888"/>
  </svg>
);

const BathIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 12H7V4C7 3.45 7.45 3 8 3C8.55 3 9 3.45 9 4V5H11V4C11 2.35 9.65 1 8 1C6.35 1 5 2.35 5 4V12H3C2.45 12 2 12.45 2 13C2 15.76 3.91 18.09 6.5 18.78V21H8V19H16V21H18V18.78C20.09 18.09 22 15.76 22 13C22 12.45 21.55 12 21 12Z" fill="#888"/>
  </svg>
);

const AreaIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 19H3V5H21V19Z" fill="#888"/>
    <path d="M6 7H18V9H6V7ZM6 11H12V13H6V11Z" fill="#888"/>
  </svg>
);

const ChevronDown = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 9L12 15L18 9" stroke="#555" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const ArrowRight = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// ── Listing Card ────────────────────────────────────────────────────
const ListingCard = ({ listing }) => {
  const { title = '', publicData } = listing.attributes;
  const id = listing.id.uuid;
  const slug = createSlug(title);

  const beds = publicData?.number_of_rooms;
  const baths = publicData?.number_of_bathrooms;
  const sqft = publicData?.usable_area;

  const firstImage = listing.images && listing.images.length > 0 ? listing.images[0] : null;
  const imageUrl =
    firstImage?.attributes?.variants?.['listing-card']?.url ||
    firstImage?.attributes?.variants?.['scaled-small']?.url ||
    firstImage?.attributes?.variants?.['default']?.url ||
    null;

  return (
    <NamedLink className={css.card} name="ListingPage" params={{ id, slug }}>
      <div className={css.cardImageWrap}>
        {imageUrl ? (
          <img className={css.cardImg} src={imageUrl} alt={title} />
        ) : (
          <div className={css.cardImgPlaceholder} />
        )}
      </div>
      <div className={css.cardBody}>
        <p className={css.cardTitle}>{title}</p>
        <div className={css.cardStats}>
          {beds != null && (
            <span className={css.cardStat}><BedIcon /> {beds}</span>
          )}
          {baths != null && (
            <span className={css.cardStat}><BathIcon /> {baths}</span>
          )}
          {sqft != null && (
            <span className={css.cardStat}><AreaIcon /> {Number(sqft).toLocaleString()} sqft</span>
          )}
        </div>
      </div>
    </NamedLink>
  );
};

// ── Filter Dropdown ─────────────────────────────────────────────────
const FilterDropdown = ({ placeholder }) => (
  <div className={css.dropdown}>
    <span className={css.dropdownText}>{placeholder}</span>
    <ChevronDown />
  </div>
);

// ── Main Component ──────────────────────────────────────────────────
const MarketplaceSection = ({ listings = [] }) => {
  const visibleListings = listings.slice(0, 16);

  return (
    <div className={css.wrapper}>
      <div className={css.container}>
        {/* Heading */}
        <div className={css.headingBlock}>
          <h2 className={css.heading}>Find the Right Suppliers</h2>
          <p className={css.subheading}>
            Browse verified construction professionals and self-build projects across the UK
          </p>
        </div>

        {/* Filter Bar */}
        {/* <div className={css.filterBar}>
          <FilterDropdown placeholder="What are you building?" />
          <div className={css.filterDivider} />
          <FilterDropdown placeholder="Type of supplier" />
          <div className={css.filterDivider} />
          <FilterDropdown placeholder="Location" />
          <button className={css.exploreBtn}>Explore Marketplace</button>
        </div> */}
        <div className={css.joinWrap}>
          <NamedLink className={css.joinBtn} name="SearchPage" to={{ search: '' }}>
            Explore Marketplace
          </NamedLink>
        </div>

        {/* Listing Grid */}
        <div className={css.grid}>
          {visibleListings.map(listing => (
            <ListingCard key={listing.id.uuid} listing={listing} />
          ))}
        </div>

        {/* Join CTA */}
        <div className={css.joinWrap}>
          <a
            className={css.joinBtn}
            href={MARKETPLACE_JOIN_CALENDLY_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Join Marketplace
          </a>
        </div>
      </div>
    </div>
  );
};

export default MarketplaceSection;
